export default "__VITE_ASSET__Bu3G$BR0__"